var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { Tag as ChakraTag, TagCloseButton, TagLabel } from "@chakra-ui/react";
import { Size, Variant } from "../../core/constants";
import { renderIcon } from "../Icon";
/**
 * Tag component is used for items that need to be labeled, categorized, or organized using keywords that describe them.
 */
const Tag = forwardRef((_a, ref) => {
    var { className, showCloseButton, children, size = Size.md, variant = Variant.solid, variantColor, colorScheme, rightIcon, leftIcon, onCloseButtonClick, isDisabled } = _a, rest = __rest(_a, ["className", "showCloseButton", "children", "size", "variant", "variantColor", "colorScheme", "rightIcon", "leftIcon", "onCloseButtonClick", "isDisabled"]);
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    return (React.createElement(ChakraTag, Object.assign({ ref: ref }, rest, { className: className, size: size, variant: variant, colorScheme: scheme }),
        leftIcon &&
            renderIcon(leftIcon, size, {
                mr: "0.3rem",
                ml: 0,
                verticalAlign: "top",
                m: undefined,
            }),
        React.createElement(TagLabel, null, children),
        rightIcon &&
            renderIcon(rightIcon, size, {
                ml: "0.3rem",
                mr: 0,
                verticalAlign: "top",
                m: undefined,
            }),
        showCloseButton && (React.createElement(TagCloseButton, { onClick: onCloseButtonClick, isDisabled: isDisabled }))));
});
Tag.displayName = "Tag";
export default Tag;
//# sourceMappingURL=Tag.js.map